import axiosClient from '../axiosClient';

export const getPoojaTypes = (params) =>
  axiosClient.get('/admin/pooja-types', { params });

export const getPoojaTypeDetail = (id) =>
  axiosClient.get(`/admin/pooja-types/${id}`);

export const createPoojaType = (data) =>
  axiosClient.post('/admin/pooja-types', data);

export const updatePoojaType = (id, data) =>
  axiosClient.put(`/admin/pooja-types/${id}`, data);

export const deletePoojaType = (id) =>
  axiosClient.delete(`/admin/pooja-types/${id}`);

export const getPoojaBookings = (params) =>
  axiosClient.get('/admin/pooja-bookings', { params });

export const getPoojaBookingDetail = (id) =>
  axiosClient.get(`/admin/pooja-bookings/${id}`);

export const updatePoojaBookingStatus = (id, status) =>
  axiosClient.patch(`/admin/pooja-bookings/${id}/status`, { status });

export const assignPoojaAstrologer = (id, astrologerId) =>
  axiosClient.patch(`/admin/pooja-bookings/${id}/astrologer`, { astrologerId });
